import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';


const monitorOrderDeleteAPI = (id, success) => {
  axios({
    method: 'DELETE',
    url: `${ROOT_URL}v1/sale/monitor_order/${id} `,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    success();
  }).catch(err => {
    if (err.data) {
      alert(JSON.stringify(err.data))
    } else {
      alert(JSON.stringify(err));
    }
  });
}

const modalStyle = {
  width: '500px',
  height: '160px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class MonitorRemove extends Component {
  state = {
    note: '',
  }

  handleConfirmClick = () => {
    const success = () => {
      this.props.handleCancelMonitorOrderSuccess();
    }
    monitorOrderDeleteAPI(this.props.monitorRow.SalesOrder_id, success);
  }

  render() {
    return (
      <form style={styles.container}>
        {/* <h4>Location Change</h4> */}
        <div>
          <h4>Unmonitor this order?</h4>
        </div>
        <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          onClick={() => {
            this.handleConfirmClick();
          }}
        >
          <Translate value="confirm" />
        </Button>
      </form>
    )
  }
}

const MonitorRemoveModal = ({ isVisible, setModalVisibility, monitorRow, handleCancelMonitorOrderSuccess }) => (
  <SkyLightStateless
    title={'Cancel Monitor'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <MonitorRemove setModalVisibility={setModalVisibility} monitorRow={monitorRow} handleCancelMonitorOrderSuccess={handleCancelMonitorOrderSuccess} />
  </SkyLightStateless>
)

MonitorRemoveModal.propTypes = propTypes
MonitorRemoveModal.defaultProps = defaultProps

export default MonitorRemoveModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/MonitorRemoveModal.jsx